import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=29d4961f&scoped=true&lang=html&"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js&"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoadingWrapper.vue?vue&type=style&index=0&id=29d4961f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4961f",
  null
  
)

export default component.exports